// src/pages/Main/Features/Features.tsx
import s from './Features.module.scss'
import React from 'react'
import { useLanguage } from 'context/LanguageContext' // Assuming you have a language context for managing translations
import { useParticlesBackground } from 'shared/hooks'
import { translations } from './translations' // Import translations
import 'particles.js'

const Features: React.FC = React.memo(() => {
    const { language } = useLanguage()
    const { header, features } = translations[language]

    useParticlesBackground('particles-js-features')

    return (
        <div className={s.wrapper}>
            <div id="particles-js-features" className={s.particles} />
            <div className={s.container}>
                <h2 className={s.header}>{header}</h2>

                <ul className={s.grid}>
                    {features.map(({ icon: Icon, text, title }, i) => (
                        <li className={s.feature} key={i}>
                            <Icon className={s.icon} />

                            <h3 className={s.title}>{title}</h3>

                            <p className={s.text}>{text}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
})

export default Features
